import React from "react";
import { Col, Row } from "reactstrap";

import useResumoCotacao from "./useResumoCotacao";
import CardIndicador, { fmtBRL, fmtNumero, fmtPct, fmtPctSigned } from "./CardIndicador";
import "../indicadoresLinha.css";

// Cards do Savings na aba "Cotação" da Torre (PO1-3628): os 4 números que a
// página do Savings já calcula em GET /indicadores/gobid/savings/cards (total
// economizado, % de economia, variação e nº de embarques). Cada card abre o
// Savings no mesmo período.
export const ROTA_SAVINGS = "/app/gobid/indicadores/savings";

export function linkSavings(periodo) {
  return `${ROTA_SAVINGS}?desde=${encodeURIComponent(periodo.desde)}&ate=${encodeURIComponent(periodo.ate)}`;
}

const mensagemErro = (erro, semEmbarcador) => {
  if (semEmbarcador) return "Selecione um embarcador no cabeçalho";
  if (!erro) return null;
  return (erro.response && erro.response.data && erro.response.data.error) || "Não foi possível carregar o Savings";
};

export function montarCards(savings, periodo) {
  const d = savings || {};
  const cards = d.cards || {};
  const variacao = d.variacaoVsPeriodoAnterior === null || d.variacaoVsPeriodoAnterior === undefined ? null : Number(d.variacaoVsPeriodoAnterior);
  const link = linkSavings(periodo);
  return {
    totalEconomizado: {
      titulo: "Total economizado",
      valor: fmtBRL(cards.totalEconomizado ? cards.totalEconomizado.valor : null),
      subtitulo: "Baseline menos valor contratado nas cotações GoBID",
      icone: "tim-icons icon-money-coins",
      tom: "icon-success",
      link,
    },
    percentualEconomia: {
      titulo: "% de economia",
      valor: fmtPct(cards.percentualEconomia ? cards.percentualEconomia.pct : null),
      subtitulo: "Economia sobre o baseline do período",
      icone: "tim-icons icon-chart-bar-32",
      tom: "icon-primary",
      link,
    },
    variacao: {
      titulo: "Variação da economia",
      valor: fmtPctSigned(variacao) || "—",
      subtitulo: "Economia comparada ao período imediatamente anterior",
      icone: variacao !== null && variacao < 0 ? "tim-icons icon-minimal-down" : "tim-icons icon-minimal-up",
      tom: variacao !== null && variacao < 0 ? "icon-danger" : "icon-success",
      link,
    },
    embarques: {
      titulo: "Embarques cotados",
      valor: fmtNumero(d.totalEmbarques),
      subtitulo: "Embarques com cotação GoBID no período",
      icone: "tim-icons icon-delivery-fast",
      tom: "icon-warning",
      link,
    },
  };
}

export const CARDS = ["totalEconomizado", "percentualEconomia", "variacao", "embarques"];

export default function CardsSavings({ deferLoad = false, onRegisterFetch, somente }) {
  const { dados, carregando, erro, periodo, semEmbarcador } = useResumoCotacao({ deferLoad, onRegisterFetch });
  const savings = dados && dados.savings;
  const erroTexto = mensagemErro((dados && dados.erroSavings) || erro, semEmbarcador);
  const cards = montarCards(savings, periodo);

  if (somente) {
    const c = cards[somente];
    return c ? <CardIndicador {...c} carregando={carregando} erro={erroTexto} /> : null;
  }
  return (
    <Row className="indicadores-linha">
      {CARDS.map((id) => (
        <Col lg md="6" key={id}>
          <CardIndicador {...cards[id]} carregando={carregando} erro={erroTexto} />
        </Col>
      ))}
    </Row>
  );
}

export const CardSavingsTotal = (props) => <CardsSavings {...props} somente="totalEconomizado" />;
export const CardSavingsPct = (props) => <CardsSavings {...props} somente="percentualEconomia" />;
export const CardSavingsVariacao = (props) => <CardsSavings {...props} somente="variacao" />;
export const CardSavingsEmbarques = (props) => <CardsSavings {...props} somente="embarques" />;
